/*
 * feature-config flag names owned by #team-assets
 */
export const ASSET_FLAG_NAMES = {
  ASSET_GENERATION_MODIFICATION:
    'ff-ast-393-asset-modification-generation-frontend',
  ASSETS_DOMAIN_PACKAGE: 'ff-ast-169-asset-domain-package',
  ASSETS_RESTRICT_FREE_DOCUMENT_UPLOAD:
    'ff-ast-94-restrict-free-document-upload',
  ASSET_SEARCH_INDEX: 'ff-ast-845-asset-search-index',
  CAMPAIGNS_AD_CREATIVES: 'ff-ast-campaigns-ad-creatives',
  CAMPAIGNS_EDIT_SCOPE_DROPDOWN: 'ff-ast-397-campaigns-edit-scope-dropdown',
  DAM_STANDALONE_ACCESS: 'ff-ast-309-dam-standalone-access',
  LAZY_LOAD_ASSETS: 'ff-ast-89-lazy-load-assets',
  PLUGIN_STORE_CONVERSION: 'ff-299-plugin-store-conversion',
  RESPONSIVE_IMAGE_MANUAL_FIX_MODAL:
    'ff-ast-344-responsive-image-manual-fix-modal',
  RESPONSIVE_IMAGE_SUPPORT_MODAL_OVERRIDE: 'ff-ast-344-support-modal-override',
  SERVER_SIDE_UPLOADS: 'ff-ast-95-server-asset-uploads',
  // Video templates (AST-475): the template picker, and the clip editor's save
  // moving to the title bar with the save card removed (AST-519).
  VIDEO_TEMPLATES: 'ff-ast-475-video-templates',
  // Gates workspace Assets public API scope issuance/refresh and route access
  // (AST-374). Default off; evaluate against the authorized workspace.
  WORKSPACE_ASSETS_PUBLIC_API: 'ff-ast-374-workspace-assets-public-api',
  WORKSPACE_ENRICHMENT: 'ff-ast-681-workspace-enrichment',
  PG_DUAL_WRITE: 'ff-ast-681-pg-dual-write',
};

export const ASSET_DYNAMIC_CONFIG_NAMES = {
  // Per-chat-id model/temperature overrides for ad-creative synthesis. Read by
  // getAdCreativesChatParams; keys are AD_CREATIVES_LLM_CHAT_IDS values.
  AI_AD_CREATIVES_CHAT_CONFIGS: 'ai-ad-creatives-chat-configs',
} as const;
